import { Menu, Transition } from "@headlessui/react"
import * as React from "react"
import { FC, Fragment, useEffect, useState } from "react"
import { KSpan } from "kahuna-base-react-components"
//@ts-ignore
import { useNavigate } from "react-router-dom"
import { users } from "../../../../../apis"
import { toast } from "react-toastify"
import { errorFilledToastOptions, successFilledToastOptions } from "../../../../../constants"
import { State51Delivery, UserTakedown } from "../../../../../types"

export type AdminUserTakedownMenuProps = {
  state51Delivery: State51Delivery
  fetchState51DeliveryList: () => void
  onResetDelivery: (state51Delivery: State51Delivery) => void
}

const AdminUserTakedownMenu: FC<AdminUserTakedownMenuProps> = (props) => {
  const [userId, setUserId] = useState<number>()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setUserId(props.state51Delivery?.userId)
  }, [props.state51Delivery])

  return (
    <Menu as="div" className="ml relative">
      <div>
        <Menu.Button data-TestId="admin-user-menu-button" className={"focus:outline-none"}>
          <div className="w-9 h-9 p-2 rounded-[10px] flex items-center justify-center bg-[#F7F7F7] hover:bg-[#F3F3F3]">
            <img
              className="min-w-5 min-h-5"
              src={"/admin_icons/horizontal-dots.svg"}
              width={20}
              height={20}
              alt="dots-icon"
            />
          </div>
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className={`z-20 origin-top-right absolute ${"right-0"} mt-2 p-2 rounded-md shadow-lg py-1 bg-[#F7F7F7] ring-1
          ring-black ring-opacity-5 focus:outline-none flex flex-col divide-y divide-gray-200`}
        >
          <div className="flex flex-col px-1 py-1 gap-1 z-20 w-[260px]">
            <Menu.Item>
              {({ active }) => (
                <div
                  className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                  onClick={() => props.onResetDelivery(props.state51Delivery)}
                >
                  <KSpan text="Reset Delivery" color="#000" />
                </div>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default AdminUserTakedownMenu
